import { useParams } from 'react-router-dom';
import { RunMetadataTable } from '@/components/runs/RunMetadataTable';
import { useLanguage } from '@/contexts/LanguageContext';
import { PageHeader } from '@/components/common/PageHeader';

/**
 * Page component for displaying all runs across all profiles in an organization
 */
export default function AllRunsPage() {
  const { t } = useLanguage();
  const { orgId } = useParams<{ orgId: string }>();

  if (!orgId) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-muted-foreground">{t.allRuns.noOrganization}</p>
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-col gap-6 min-h-0">
      <PageHeader title={t.allRuns.title} description={t.allRuns.description} />

      <RunMetadataTable
        orgId={orgId}
        showProfileColumn={true}
        title={t.allRuns.runHistory}
        storageKey="allRuns.columnVisibility"
        fillHeight
      />
    </div>
  );
}
